import * as types from './types'

export const updateActionMessage = (message) => ({
  type: types.UPDATE_ACTION_MESSAGE,
  message,
})
